import React, { useEffect, useRef, useState } from "react";
import SubHeader from "../customComponents/SubHeader";
import { Autocomplete, TextField } from "@mui/material";
import { useSelector } from "react-redux";
import api from "../../utils/axiosInstance";
import AccountLedgerTable from "./Scheme/AccountLedgerTable";
import moment from "moment";
import { ChevronRight } from "@mui/icons-material";
import DateFilters from "../customComponents/common/DateFilters";
import { message } from "antd";

const optionsDummy = [
  {
    name: "Rahul Sharma",
    acctype: "Savings",
    accno: "ACC1001",
  },
  {
    name: "Amit Verma",
    acctype: "Current",
    accno: "ACC1002",
  },
  {
    name: "Sneha Patel",
    acctype: "Savings",
    accno: "ACC1003",
  },
  {
    name: "Karan Mehta",
    acctype: "Fixed Deposit",
    accno: "ACC1004",
  },
  {
    name: "Priya Nair",
    acctype: "Savings",
    accno: "ACC1005",
  },
  {
    name: "Rohit Gupta",
    acctype: "Current",
    accno: "ACC1006",
  },
  {
    name: "Neha Singh",
    acctype: "Savings",
    accno: "ACC1007",
  },
  {
    name: "Vikas Yadav",
    acctype: "Recurring Deposit",
    accno: "ACC1008",
  },
  {
    name: "Pooja Desai",
    acctype: "Savings",
    accno: "ACC1009",
  },
  {
    name: "Ankit Tiwari",
    acctype: "Current",
    accno: "ACC1010",
  },
];

const DummyBranchOptions = [
  { name: "Shastri Nagar", city: "Meerut", state: "Uttar Pradesh" },
  { name: "Ganga Nagar", city: "Meerut", state: "Uttar Pradesh" },
  { name: "Modipuram", city: "Meerut", state: "Uttar Pradesh" },
];

const tableConfig = [
  {
    key: "date",
    label: "Date",
    width: "30%",
    align: "left",
    dataKey: "col1",
  },
  {
    key: "narration",
    label: "Narration",
    width: "30%",
    align: "left",
    dataKey: "narration",
  },
  {
    key: "debit",
    label: "Debit",
    width: "13%",
    align: "right",
    dataKey: "Debit",
  },
  {
    key: "credit",
    label: "Credit",
    width: "13%",
    align: "right",
    dataKey: "credit",
  },
];

const AccountLedger = ({ toggleMobileMenu }) => {
  const [tableData, setTableData] = useState([]);
  const [customerArray, setCustomerArray] = useState([]);
  const [loading, setLoading] = useState(false);
  const [branchOptions, setBranchOptions] = useState([]);
  // const branchOptions = useSelector((state) => state.user.webidInfo);
  const searchBoxRef = useRef();
  const debounceTimeout = useRef(null); // Ref to store the timeout
  const [errorInfo, setErrorInfo] = useState({
    flag: false,
    message: "",
  });

  const [formData, setFormData] = useState({
    name: "",
    branchName: "",
    webid: "",
    cutomerAccName: "",
    customerAccno: "",
    from: moment(new Date()).format("YYYY-MM-DD"),
    to: moment(new Date()).format("YYYY-MM-DD"),
  });

  const handleOptionSelect = (name, value) => {
    setErrorFalse();
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const setErrorFalse = () => {
    setErrorInfo((e) => ({ flag: false }));
  };

  const getBranch = async (all, search) => {
    try {
      setLoading(true);
      const response = await api.post("/user/erp-data");
      if (response.data.success) {
        setBranchOptions(response.data.data.webidInfo);
        setLoading(false);
      } else {
        setBranchOptions([]);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getCustomer = async (all, search) => {
    try {
      setLoading(true);
      const response = await api.post("/branch-reports/get-customers", {
        all,
        search,
        webid: formData.webid,
      });
      if (response.data.success) {
        setCustomerArray(response.data.data);
        setLoading(false);
      } else {
        setCustomerArray([]);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getAccountLedgerData = async (data) => {
    if (!formData.webid || !formData.customerAccno) {
      setErrorInfo({
        flag: true,
        message: "Branch and customer are mandatory to select",
      });
    }
    try {
      setLoading(true);
      const response = await api.post("/branch-reports/get-account-ledger", {
        data,
      });

      if (response.data.success) {
        console.log("invoice Data:", response.data.data);
        setTableData(response.data.data);
      } else {
        setErrorInfo({
          flag: true,
          message: "Branch and customer are mandatory to select",
        });
        setTableData(null);
      }
    } catch (error) {
      setErrorInfo({
        flag: true,
        message: "server error ",
      });
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    console.log("handle search: ", e);
    const { value } = e.target;
    if (value && value !== "") {
      setFormData((pre) => ({
        ...pre,
        // name:value
      }));

      // Debouncing logic
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      debounceTimeout.current = setTimeout(() => {
        getCustomer(false, value);
      }, 1000); // 1-second delay
    }
  };

  useEffect(() => {
    getCustomer(false, "");
  }, [formData.webid]);
  useEffect(() => {
    getBranch();
  }, []);
  return (
    <>
      <SubHeader text={"Account Ledger"} toggleMobileMenu={toggleMobileMenu} />
      <div className="w-full mx-auto px-4 lg:px-2">
        <div className="relative w-full lg:min-h-[550px] rounded-[10px] mt-8 mb-2 shadow-custom-dark">
          <div className="w-full py-4 lg:pt-6 px-4 lg:px-8">
            <div>
              <div className="font-mont font-semibold pb-2">Account Ledger</div>
              <div className="flex flex-col lg:flex-row my-4 px-0 lg:px-2 gap-4 lg:gap-8 lg:items-end mt-4 lg:mt-0">
                <div className="lg:w-[200px]">
                  <Autocomplete
                    size="small"
                    freeSolo
                    autoHighlight
                    inputValue={formData?.branchName || ""}
                    onInputChange={(event, newInputValue) => {
                      handleOptionSelect("branchName", newInputValue);
                    }}
                    onChange={(event, newValue) => {
                      handleOptionSelect("webid", newValue?.webid);
                    }}
                    options={branchOptions}
                    getOptionLabel={(option) => {
                      return option.accname;
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        autoComplete="text"
                        label="Branch."
                        inputRef={searchBoxRef}
                      />
                    )}
                  />
                </div>
                <div className="lg:w-[540px]">
                  <Autocomplete
                    size="small"
                    freeSolo
                    autoHighlight
                    inputValue={formData?.cutomerAccName || ""}
                    onInputChange={(event, newInputValue, reason) => {
                      handleOptionSelect("cutomerAccName", newInputValue);
                      handleSearch(event);
                    }}
                    onChange={(event, newValue) => {
                      handleOptionSelect("customerAccno", newValue?.accno);
                    }}
                    options={customerArray}
                    getOptionLabel={(option) => {
                      return option.accname;
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        autoComplete="text"
                        label="Customer Name."
                        inputRef={searchBoxRef}
                      />
                    )}
                  />
                </div>
                {errorInfo.flag && <div className="text-red-600">{errorInfo.message} </div>}
              </div>
                
              <div className="flex flex-col lg:flex-row my-4 px-0  lg:px-2 gap-4 lg:gap-8 lg:items-end mt-4 lg:mt-0">
                <TextField
                  sx={{ width: { xs: "200px" } }}
                  value={formData.from}
                  label="From"
                  variant="standard"
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      from: e.target.value,
                    }));
                  }}
                  type="date"
                />
                <TextField
                  sx={{ width: { xs: "200px" } }}
                  value={formData.to}
                  label="To"
                  variant="standard"
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      to: e.target.value,
                    }));
                  }}
                  type="date"
                />
              </div>

              <div className="">
                <DateFilters
                  getOrderData={getAccountLedgerData}
                  formData={formData}
                  setFormData={setFormData}
                />
              </div>
            </div>
          </div>

          <div className="w-full px-4 lg:px-7 pb-6">
            <AccountLedgerTable
              tableData={tableData ? tableData : {}}
              isLoading={loading}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountLedger;
